export function getShortCustomFieldFieldName(field: string) {
  return field.replace('formattedData.customFields.', '')
}
